import { EntityClaim } from "../entity/EntityClaim";

export class DtoClaimNumsGetRes {
  //一覧用
  //-----------------------
  public items: EntityClaim[] = [];
}
